export default "__VITE_ASSET__CPfV2IB7__"